<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="fromRole" ref="fromToken" class="demo-form-inline">
                <el-row :gutter="20">
                    <el-form-item label="TAG" label-width="60px">
                        <td-input placeholder="common.PLEASE_INPUT" v-model="fromToken.tag"></td-input>
                    </el-form-item>
                    <el-form-item :label="$t('tokenInfo.GENERATE_DATE')" label-width="80px">
                        <td-date-time :editable="false" v-model="fromToken.generateStartTime" type="date" :pickerOptions="pickerBeginDateBefore" :placeholder="$t('common.START_TIME')"></td-date-time>
                    </el-form-item>
                    <el-form-item :label="$t('common.UNTIL')" label-width="40px">
                        <td-date-time :editable="false" v-model="fromToken.generateEndTime" type="date" :pickerOptions="pickerBeginDateAfter" :placeholder="$t('common.END_TIME')"></td-date-time>
                    </el-form-item>
                    <el-form-item class="paddingLeft10">
                        <td-button type="primary" :loading="queryLoading" @click.native="queryPageList()">{{ $t('common.QUERY') }}</td-button>
                        <td-button type="button" @click.native="generateToken">{{ $t('tokenInfo.GENERATE') }}</td-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :hasMutiSelect="false"
                rowKey="roleId"
                :hasLoading="tableLoading"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
            ></td-table>
            <dialog-token
                v-if="dialogTokenVisible"
                :isDetail="isDetail"
                :editItem="editItem"
                :dialogTokenVisible="dialogTokenVisible"
                :sysFlg="sysFlg"
                :sysList="sysList"
                @tokenDialogClose="tokenDialogClose"
            ></dialog-token>
        </el-main>
    </el-container>
</template>
<script>
import resourceApi from './../user/assets/api.js';
import dialogToken from './components/dialogToken.vue';
export default {
    components: {
        dialogToken
    },
    created() {
        // 进行页面初始化数据的加载
        this.queryPageList();
        this.initSysList();
    },
    // 监听时间
    watch: {
        ['fromToken.generateStartTime'](val) {
            let dateVal = this.formRoleInfo.generateEndTime;
            if (dateVal && val && new Date(val).getTime() > new Date(dateVal).getTime()) {
                this.formRoleInfo.generateEndTime = val;
            }
        },
        ['fromToken.generateEndTime'](val) {
            let dateVal = this.formRoleInfo.generateStartTime;
            if (dateVal && val && new Date(dateVal).getTime() > new Date(val).getTime()) {
                this.formRoleInfo.generateStartTime = val;
            }
        }
    },
    data() {
        return {
            fromToken: {
                tag: '',
                generateStartTime: '',
                generateEndTime: ''
            },
            isDetail: false,
            editItem: '',
            tableData: [],
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            queryLoading: false,
            tableLoading: false,
            dialogTokenVisible: false,
            sysList: [],
            sysFlg: '',
            pickerBeginDateBefore: {
                disabledDate: time => {
                    let dateVal = this.fromToken.generateEndTime;
                    if (dateVal) {
                        return time.getTime() > new Date(Date.parse(String(dateVal).replace(/-/g, '/'))).getTime();
                    }
                }
            },
            pickerBeginDateAfter: {
                disabledDate: time => {
                    let dateVal = this.fromToken.generateStartTime;
                    if (dateVal) {
                        return time.getTime() <= new Date(Date.parse(String(dateVal).replace(/-/g, '/'))).getTime() - 8.64e7;
                    }
                }
            },
            columns: [
                {
                    prop: 'dtCreateTime',
                    align: 'center',
                    label: this.$t('tokenInfo.GENERATE_DATE')
                },
                {
                    prop: 'tag',
                    label: 'TAG'
                },
                {
                    prop: 'dateTo',
                    align: 'center',
                    label: this.$t('tokenInfo.VALID_TIME')
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    tableWidth: '180',
                    align: 'center',
                    render: (createElement, params) => {
                        let result = [];
                        if (params.row.roleType !== 1) {
                            let dayailBtn = createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDetail(params.row);
                                        }
                                    }
                                },
                                this.$t('common.DETAIL')
                            );
                            let stopBtn = createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnStopToken(params.row);
                                        }
                                    }
                                },
                                params.row.iLockType == 0 ? this.$t('tokenInfo.STOP_TOKEN') : this.$t('tokenInfo.NO_LOCK')
                            );
                            let delBtn = createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDelete(params.row.userId);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            );
                            result = [dayailBtn, stopBtn, delBtn];
                        }
                        return createElement('div', result);
                    }
                }
            ]
        };
    },
    methods: {
        //详情
        btnDetail(row) {
            this.isDetail = true;
            this.editItem = row;
            this.dialogTokenVisible = true;
        },
        //停用/解锁
        btnStopToken(row) {
            this.tableLoading = true;
            let param = {
                sId: row.userId,
                lockUserOnly: true,
                iLockType: row.iLockType == 0 ? 1 : 0
            };
            resourceApi.updateUserInfo(JSON.stringify(param), response => {
                this.tableLoading = false;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('usr/updateUserInfo', response.data.statusMessage);
                }
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                this.btnQuery();
            });
        },
        //删除
        btnDelete(id) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = {
                        sId: id,
                        sysFlg: this.sysFlg
                    };
                    resourceApi.deleteUserInfo(JSON.stringify(param), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$log.error('usr/deleteUserInfo', response.data.statusMessage);
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.btnQuery();
                    });
                })
                .catch(() => {
                    this.$log.error('user/deleteUserInfo---- Fail');
                });
        },
        initSysList() {
            //系统标识sysFlg
            if (sessionStorage.systemId) {
                this.sysFlg = sessionStorage.systemId;
            } else {
                this.sysFlg = 'PG';
            }
            //sysList
            let param = {};
            resourceApi.getSysList(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('sys/getSysList', response.data.statusMessage);
                }
                this.sysList = response.data.content;
            });
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.btnQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.btnQuery();
        },
        // 查询数据
        queryPageList() {
            this.currentPage = 1;
            this.btnQuery();
        },
        btnQuery() {
            this.queryLoading = true;
            this.tableLoading = true;
            let param = {
                tag: this.fromToken.tag,
                startTime: this.fromToken.generateStartTime,
                endTime: this.fromToken.generateEndTime,
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                sysFlg: this.sysFlg
            };

            resourceApi.queryTokenList(param, response => {
                this.queryLoading = false;
                this.tableLoading = false;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('token/queryTokenList', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content.resultlist;
                this.total = response.data.content.total;
                this.loading = false;
            });
        },
        //点击生成
        generateToken() {
            this.dialogTokenVisible = true;
        },
        //dialog关闭
        tokenDialogClose() {
            this.dialogTokenVisible = false;
            this.isDetail = false;
            this.btnQuery();
        }
    }
};
</script>
<style scoped></style>
